<template>
    <div>
        <div>
              <b-row>
                <b-col>
                  <div>
      <b-card no-body>
        <b-tabs card>
          <b-tab title="Consumable Tracking" active>
            <b-card-group deck>
              <b-card no-body header-bg-variant="info" border-variant="info" header="Monthly Consumables Savings" class="text-center">
            <b-row no-gutters>
              <b-col>
              <b-card-body>
                <b-card-text>
                  <br/>
                  <h5>Soap & Gel Savings : 21 Litres</h5>
                </b-card-text>
              </b-card-body>
            </b-col>
           </b-row>
          </b-card>
            <b-card>
              <b-row>
                <b-col><b-button block variant="outline-info" size="sm" v-b-modal.consumablesordermodal>Order Consumables</b-button>
                  </b-col>
                  </b-row>
            </b-card>

          </b-card-group>
            <b-table
                    sticky-header
                    id="Consumables Table"
                    :items="consumableitems"
                    :fields="consumablefields"
                    no-border-collapse
                    hover
                    head-variant="light"
                    show-empty
                    responsive
                    empty-text="You currently dont have any Endpoints of this type"
                    small
                  >

                    <template v-slot:cell(ShowDetails)="{ item }">
                      <b-button
                        variant="outline-info"
                        size="sm"
                        v-on:click="showActionModal(item)">
                        Details
                      </b-button>
                    </template>
                    <template v-slot:cell(EstWashesRemaining)="{ item }">
        <span :class="{ 'text-green': item.EstWashesRemaining >= 300, 'text-red': item.EstWashesRemaining <= 150, 'text-orange': item.EstWashesRemaining <300 && item.EstWashesRemaining >150 }">
        {{ item.EstWashesRemaining }}
        </span>
      </template>
                  </b-table>
                  <b-row><b-col><br></b-col></b-row>
            </b-tab>
        <b-tab title="Card Management">
          <b-card-group deck>
            <b-card>
              <b-row>
                <b-col>Handwash Cards:</b-col><b-col><b-avatar variant="info" rounded size="1.75em">26</b-avatar></b-col>
              </b-row>
              <b-row>
                <b-col>Sample Cards:</b-col><b-col><b-avatar variant="info" rounded size="1.75em">4</b-avatar></b-col>
              </b-row>
              <b-row>
                <b-col>Cleaner Cards:</b-col><b-col><b-avatar variant="info" rounded size="1.75em">6</b-avatar></b-col>
              </b-row>
              <b-row>
                <b-col>Consumables Cards:</b-col><b-col><b-avatar variant="info" rounded size="1.75em">2</b-avatar></b-col>
              </b-row>
            </b-card>
            <b-card>
              <b-row>
                <b-col><b-button block variant="outline-info" size="sm" v-b-modal.cardsordermodal>Request Cards</b-button>
                  </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                <b-button block variant="outline-info" size="sm" v-b-modal.cardscancelmodal>Cancel Cards</b-button></b-col>
              </b-row>
              <b-row>
                <b-col><b-button block variant="outline-info" size="sm" v-b-modal.cardsassignmodal>Assign New Cards</b-button>
                  </b-col>
                  </b-row>
                  <b-row>
                  <b-col><b-button block variant="outline-info" size="sm" v-b-modal.cardsreassignmodal>Re-Assign Cards</b-button></b-col>
              </b-row>
            </b-card>

          </b-card-group>
          <b-card>
            Table here showing current assigned cards or numbers
          </b-card>
        </b-tab>
        </b-tabs>
        </b-card>
                    </div>
                </b-col>
            </b-row>
        </div>
        <b-modal ref="consumablesmodal"
        id="consumablesmodal"
        title="Consumables"
        content-class="Modal"
        header-bg-variant="light"
        hide-footer
        lazy>
      <b-card
        border-variant="dark"
        align="center"
        header-bg-variant="secondary"
        footer-tag="footer"
      >
      <b-card-sub-title class="mb-2">{{ this.item1}}</b-card-sub-title>
        <b-row></b-row>
        <template #header>
          <h4 class="left">{{ item0 }}</h4>
        </template>
        <b-card-body>
          <b-card no-body header-bg-variant="info" border-variant="info" header="Monthly Consumables Savings" class="text-center">
    <b-row no-gutters>
      <b-col>
        <b-card-body>
          <b-card-text>
            <br/>
            <h5>Soap & Gel Savings : {{this.item7}} Litres</h5>
          </b-card-text>
        </b-card-body>
      </b-col>
    </b-row>
  </b-card>
          <b-card-group deck>
          <b-card header="Soap">
            <b-row><b-col>Enabled:</b-col></b-row>
            <b-row><b-col>{{ this.item2 }}</b-col></b-row>
            <b-row><b-col>Last Changed:</b-col></b-row>
            <b-row><b-col>{{ this.item3 }}</b-col></b-row>
          </b-card>
          <b-card header="Alcohol">
            <b-row><b-col>Enabled:</b-col></b-row>
            <b-row><b-col>{{ this.item4 }}</b-col></b-row>
            <b-row><b-col>Last Changed:</b-col></b-row>
            <b-row><b-col>{{ this.item5 }}</b-col></b-row>
          </b-card>
          </b-card-group>
          <b-card :header-bg-variant="HandwashesRemainColour">
            <template #header>
              Est Handwash Remaining: <h4>{{ item6 }}</h4>
            </template>
            <b-button block variant="outline-info" v-b-modal.consumablesordermodal>Order Additional Consumables</b-button>
          </b-card>
        </b-card-body>
      </b-card>
      </b-modal>  
      <b-modal ref="consumablesordermodal"
        id="consumablesordermodal"
        title="Consumables Order"
        content-class="Modal"
        header-bg-variant="light"
        lazy
        hide-footer>
        <b-card>
          <b-row><b-col>Order Location: {{ location }}</b-col></b-row>
          <b-row><b-col><br></b-col></b-row>
          <b-row><b-col>
          <b-form-group label="Consumable To Order">
          <b-form-checkbox-group
            id="Consumable Order"
            v-model="productselected"
             name="ConsumableOrder"
      > 
        <b-form-checkbox value="soap">Soap</b-form-checkbox>
        <b-form-checkbox value="alcohol">Alcohol</b-form-checkbox>
        <b-form-checkbox value="papertowels">Paper Towels</b-form-checkbox>
      </b-form-checkbox-group>
    </b-form-group>
  </b-col>
    </b-row>
    <b-row v-if= "productselected.includes('soap')"><b-col>No of soap boxes/bags: <b-form-select v-model="soapquantity" :options="options"></b-form-select></b-col></b-row>
    <b-row v-if="productselected.includes('alcohol')"><b-col>No of alcohol boxes/bags: <b-form-select v-model="alcoholquantity" :options="options"></b-form-select></b-col></b-row>
    <b-row v-if="productselected.includes('papertowels')"><b-col>No of towel boxes: <b-form-select v-model="towelquantity" :options="options"></b-form-select></b-col></b-row>
    <b-card>
      <b-row><b-col>Delivery details:</b-col></b-row>
      <b-row><b-col>Contact: Show estates contact name</b-col></b-row>
      <b-row></b-row>
    </b-card>
          <b-row>
            <b-col>
            <b-button variant="outline-info" @click="submitorder()">Submit</b-button>
            <b-button variant="outline-info" @click="cancelorder()">Cancel</b-button>
            </b-col>
          </b-row>
        </b-card>
        </b-modal>
        <b-modal ref="cardsordermodal"
        id="cardsordermodal"
        title="Cards Order"
        content-class="Modal"
        header-bg-variant="light"
        lazy
        hide-footer>
        <b-card>
          <b-row><b-col>Order Location: {{ location }}</b-col></b-row>
          <b-row><b-col><br></b-col></b-row>
          <b-row><b-col>
          <b-form-group label="Card Type To Order">
          <b-form-checkbox-group
            id="Card Order"
            v-model="cardselected"
             name="CardOrder"
      > 
        <b-form-checkbox value="handwash">Handwash</b-form-checkbox>
        <b-form-checkbox value="sample">Water Sample</b-form-checkbox><br>
        <b-form-checkbox value="cleaning">Cleaning</b-form-checkbox>
        <b-form-checkbox value="consumable">Consumable</b-form-checkbox>
      </b-form-checkbox-group>
    </b-form-group>
  </b-col>
    </b-row>
    <b-row v-if= "cardselected.includes('handwash')"><b-col>No of Handwash Cards: <b-form-input v-model="handwashquantity" placeholder="Enter Quantity"></b-form-input></b-col></b-row>
    <b-row v-if="cardselected.includes('sample')"><b-col>No of Sample Cards: <b-form-input v-model="samplequantity" placeholder="Enter Quantity"></b-form-input></b-col></b-row>
    <b-row v-if="cardselected.includes('cleaning')"><b-col>No of Cleaning Cards: <b-form-input v-model="cleaningquantity" placeholder="Enter Quantity"></b-form-input></b-col></b-row>
    <b-row v-if="cardselected.includes('consumable')"><b-col>No of Consumable Cards: <b-form-input v-model="consumablequantity" placeholder="Enter Quantity"></b-form-input></b-col></b-row>
    <b-card>
      <b-row><b-col>Delivery details:</b-col></b-row>
      <b-row><b-col>Contact: Show estates contact name</b-col></b-row>
      <b-row></b-row>
    </b-card>
          <b-row>
            <b-col>
            <b-button variant="outline-info" @click="submitcardorder()">Submit</b-button>
            <b-button variant="outline-info" @click="cancelcardorder()">Cancel</b-button>
            </b-col>
          </b-row>
        </b-card>
        </b-modal>
          <b-modal ref="cardscancelmodal"
        id="cardscancelmodal"
        title="Cancel Cards"
        content-class="Modal"
        header-bg-variant="light"
        lazy
        hide-footer>
          <b-card>
            Cancel Cards
          </b-card>
        </b-modal>
        <b-modal ref="cardsassignmodal"
        id="cardsassignmodal"
        title="Assign New Cards"
        content-class="Modal"
        header-bg-variant="light"
        lazy
        hide-footer>
          <b-card>
            Assign New Cards
          </b-card>
        </b-modal>
        <b-modal ref="cardsreassignmodal"
        id="cardsreassignmodal"
        title="Reassign Cards"
        content-class="Modal"
        header-bg-variant="light"
        lazy
        hide-footer>
          <b-card>
            Re-Assign Cards
          </b-card>
        </b-modal>
    </div>
</template>

<script>

    
    
    
    export default {
      
      computed: {
    
      },
      components: {

      },
    
      data() {
        return{
          consumablefields:[
            {key:'UnitID',stickyColumn: true, isRowHeader: true,},
            {key:'UnitLocation'},
            {key:'SoapEnabled'},
            {key:'SoapLastChanged'},
            {key: 'AlcoholEnabled'},
            {key: 'AlcoholLastChanged'},
            {key: 'EstWashesRemaining'},
            {key: 'ShowDetails'}],
          consumableitems:[
            {UnitID:'GABs987ys779',UnitLocation: 'Dental',SoapEnabled: 'True', SoapLastChanged: '03/01/2023',AlcoholEnabled: 'True',AlcoholLastChanged: '03/01/2023',EstWashesRemaining: '521',EstSavings: "4"},
            {UnitID:'MIC186262567',UnitLocation: 'Ward 1',SoapEnabled: 'True', SoapLastChanged: '12/01/2023',AlcoholEnabled: 'True',AlcoholLastChanged: '12/01/2023',EstWashesRemaining: '854',EstSavings: "1"},
            {UnitID:'MICd8d7gd7gh',UnitLocation: 'ICU Triage',SoapEnabled: 'True', SoapLastChanged: '23/12/2023',AlcoholEnabled: 'True',AlcoholLastChanged: '21/12/2023',EstWashesRemaining: '289',EstSavings: "2.4"},
            {UnitID:'GAB28hshhu88',UnitLocation: 'ICU Room 3',SoapEnabled: 'True', SoapLastChanged: '08/01/2023',AlcoholEnabled: 'True',AlcoholLastChanged: '08/01/2023',EstWashesRemaining: '73',EstSavings: "6.9"}
          ],
          item0: "",
          item1: "",
          item2: "",
          item3: "",
          item4: "",
          item5: "",
          item6: "",
          item7: "",
          HandwashesRemainColour: "",
          location: localStorage.getItem("CurrentLocation"),
          options: [{ value: null, text: 'Please select quantity' },
          { value: '1', text: '1' },
          { value: '2', text: '2' },
          { value: '3', text: '3' },
          { value: '4', text: '4' },
          { value: '5', text: '5' },
          { value: '6', text: '6' },
          { value: '7', text: '7' },
          { value: '8', text: '8' },
          { value: '9', text: '9' },],
          soapquantity:"",
          alcoholquantity: "",
          towelquantity: "",
          productselected:[],
          handwashquantity: "",
          samplequantity: "",
          cleaningquantity: "",
          consumablequantity: "",
          cardselected: []
        };
      
      },
    
    
      beforeMount() {
    
      
    
          
        },
    
    
    
      mounted(){
    
         
              
    
      }, 
    
     
      methods: {

        showActionModal(item){
        this.item0 = item.UnitID;
        this.item1 = item.UnitLocation;
        this.item2 = item.SoapEnabled;
        this.item3 = item.SoapLastChanged;
        this.item4 = item.AlcoholEnabled;
        this.item5 = item.AlcoholLastChanged;
        this.item6 = item.EstWashesRemaining;
        this.item7 = item.EstSavings;

        if (this.item6 >= 300 ) {
        this.HandwashesRemainColour = "success"
        }
        else if (this.item6 <= 150){
          this.HandwashesRemainColour = "danger"
        }
        else if (this.item6 <300 && this.item6 >150){
          this.HandwashesRemainColour = "warning"
        }
        else {
          this.HandwashesRemainColour = "secondary"
        }

        this.$refs['consumablesmodal'].show(this.item0,this.item1,this.item2,this.item3,this.item4,this.item5,this.item6,this.item7)
        },
        cancelorder(){
          this.soapquantity = "",
          this.alcoholquantity = "",
          this.towelquantity = "",
          this.productselected = []
          this.$refs['consumablesordermodal'].hide()
        },
        submitorder(){
          alert('Order for ' + this.location + ' submitted, order contains: ' + this.soapquantity + ' soap bags, ' + this.alcoholquantity + ' alcohol bags, and ' + this.towelquantity + ' boxes of towels')
          this.soapquantity = "",
          this.alcoholquantity = "",
          this.towelquantity = "",
          this.productselected = []
          this.$refs['consumablesordermodal'].hide()
        },
        cancelcardorder(){
          this.handwashquantity = "",
          this.cleaningquantity = "",
          this.samplequantity = "",
          this.consumablequantity= "",
          this.cardselected = []
          this.$refs['cardsordermodal'].hide()
        },
        submitcardorder(){
          alert('Order for ' + this.location + ' submitted, order contains: ' + this.handwashquantity + ' handwash cards, ' + this.samplequantity + ' sample cards, ' + this.cleaningquantity + ' cleaning cards, and ' + this.consumablequantity + ' consumable cards')
          this.handwashquantity = "",
          this.cleaningquantity = "",
          this.samplequantity = "",
          this.consumablequantity= "",
          this.cardselected = []
          this.$refs['cardsordermodal'].hide()
        }
      },
    }
     

    </script>
    
    <style>

.text-red {
    background-color: lightcoral
  }
  
  .text-green {
    background-color: lightgreen;
  }

  .text-orange {
    background-color: orange;
  }
    
    </style>
    

 



